import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {
  return (
    <div className='splash-screen'>
      {/* THEME: LOGO */}
      <img src={toAbsoluteUrl('/media/saas/admm.png')} alt='ADMM' />
      <span>Loading ...</span>
    </div>
  )
}
